var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer mt-auto py-3"},[_c('div',{staticClass:"container"},[_c('span',{staticClass:"text-muted"},[_vm._v("© "+_vm._s(_vm.currentYear)+" - Sanibel Cyber Tech")])])])}
var staticRenderFns = []

export { render, staticRenderFns }